import { useQuery } from '@tanstack/react-query';
import type AgentApiAllianceChatMessagesIndex from '@/types/serializers/AgentApiAllianceChatMessagesIndex';

export const AGENT_ALLIANCE_CHAT_MESSAGES_QUERY_KEY = ['agent_alliance_chat_messages'] as const;

export default function useFetchAllianceChatMessages(applicationId: string | null) {
  return useQuery({
    queryKey: [...AGENT_ALLIANCE_CHAT_MESSAGES_QUERY_KEY, applicationId],
    enabled: applicationId !== null,
    queryFn: async () => {
      const response = await fetch(
        `/agent/api/alliance_applications/${applicationId}/chat_messages?per_page=200`
      );
      if (!response.ok) throw new Error('メッセージの取得に失敗しました');
      const data: AgentApiAllianceChatMessagesIndex = await response.json();
      return data;
    },
  });
}
